import * as React from 'react';
import { useContext } from 'react';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import ProfileSectionWithTitle from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileSectionWithTitle';
import ProjectsSection from 'bundles/account-profile/components/recruiting-profile-viewer/components/projects/ProjectsSection';
import WorkHistorySection from 'bundles/account-profile/components/recruiting-profile-viewer/components/work-history/WorkHistorySection';
import { useEnableProjectEnhancements } from 'bundles/employability-common/feature-flags/hooks/useEnableProjectEnhancements';
import { shouldEnablePortfolioProjects } from 'bundles/employability-common/feature-flags/projectsEpicFeatureFlags';

import _t from 'i18n!nls/account-profile';

const ExperienceSection = () => {
  const { isProfileLoading, profileState = {}, editable } = useContext(ProfileContext);
  const { workHistory, completedPortfolioProjects } = profileState;
  const enableProjectEnhancements = useEnableProjectEnhancements();

  const enableProjectsSection = shouldEnablePortfolioProjects() || enableProjectEnhancements;

  const showPortfolioProjects = enableProjectsSection && !!completedPortfolioProjects?.length;

  // This check is to prevent us from rendering the section when both the projects section and the work history section are not rendered
  if (!editable && !isProfileLoading && !workHistory?.length && !showPortfolioProjects) {
    return null;
  }

  return (
    <ProfileSectionWithTitle title={_t('Experience')}>
      {enableProjectsSection && <ProjectsSection />}
      <WorkHistorySection />
    </ProfileSectionWithTitle>
  );
};

export default ExperienceSection;
